/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Session_Delete_TitleInputs */

const en_ui_session_delete_title = /** @type {(inputs: Ui_Session_Delete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete Session`)
};

const de_ui_session_delete_title = /** @type {(inputs: Ui_Session_Delete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einheit löschen`)
};

/**
* | output |
* | --- |
* | "Delete Session" |
*
* @param {Ui_Session_Delete_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_session_delete_title = /** @type {((inputs?: Ui_Session_Delete_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Session_Delete_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_session_delete_title(inputs)
	return de_ui_session_delete_title(inputs)
});